<template>
    <v-row>
        <v-col cols="5" offset="1" class="pt-0">
            <date-picker
                :value="startFromValue"
                :hide-label-block="true"
                @input="$emit('updateStartOfRange', $event)"
            ></date-picker>
        </v-col>
        <v-col class="shrink px-3 align-self-center pt-0">
            -
        </v-col>
        <v-col cols="5" class="pt-0">
            <date-picker
                :value="endFromValue"
                :hide-label-block="true"
                @input="$emit('updateEndOfRange', $event)"
            ></date-picker>
        </v-col>
    </v-row>
</template>

<script>

export default {
    name: "DateRange",
    props: {
        startFromValue: {
            type: Date,
            default: null
        },
        endFromValue: {
            type: Date,
            default: null
        }
    }
}

</script>

<style scoped lang="scss">

</style>